import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { actions } from '../redux';

export default function useBetsAccordion(id) {
  const dispatch = useDispatch();
  const { actionProcessing } = useSelector(state => state.sportHistory);
  const [isOpen, setIsOpen] = useState(false);
  const [bets, setBets] = useState([]);

  const callback = data => {
    setBets(data);
    setIsOpen(true);
  };

  const errorCallback = () => {
    setIsOpen(false);
  };

  const handleClick = () => {
    if (!isOpen) {
      dispatch(actions.getCouponBets({ id, callback, errorCallback }));
    } else {
      setIsOpen(false);
      setBets([]);
    }
  };

  return {
    isOpen,
    bets,
    actionProcessing,
    handleClick,
  };
}
